import { Card, mergeClasses, Text, tokens } from '@fluentui/react-components';
import { ReactNode } from 'react';

import EnhancedExternalLink from 'src/components/atoms/enhanced-external-link/EnhancedExternalLink';
import FatSideBarAccent from 'src/components/atoms/fat-side-bar-accent/FatSideBarAccent';
import { useChallengeItemStyles } from './ChallengeItem.styles';

export interface ChallengeItemProps {
  name: string
  accentColor?: string
  icon: ReactNode
  actionUri: string
  description: string
  actionText: string
  className?: string
}

const ChallengeItem: React.FC<ChallengeItemProps> = ({
  name,
  accentColor = tokens.colorNeutralBackground1,
  icon,
  actionUri,
  description,
  actionText,
  className = '',
}: ChallengeItemProps) => {
  const styles = useChallengeItemStyles();
  const container = mergeClasses('challenge-item-container-avatar', styles.container, className);
  return (
    <Card className={container} data-testid="challengeItem">
      <div className={styles.containerWrap}>
        <FatSideBarAccent name={name} icon={icon} accentColor={accentColor} />
        <div data-testid="right" className={styles.cardContent}>
          <Text className={styles.title}>{name}</Text>

          <div>
            <Text className={styles.description}>{description}</Text>
          </div>

          <div className={styles.cardActions}>
            <div className={styles.cardActionContainer}>
              <EnhancedExternalLink
                target="_blank"
                href={actionUri}
                className={styles.link}
                aria-label={`${actionText} about ${name}`}
                rel="noopener noreferrer"
              >
                {actionText}
              </EnhancedExternalLink>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ChallengeItem;
